import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import it_common from "./locales/it/common.json";
import it_nav from "./locales/it/nav.json";
import it_dashboard from "./locales/it/dashboard.json";
import it_tables from "./locales/it/tables.json";
import it_cards from "./locales/it/cards.json";
import it_producers from "./locales/it/producers.json";
import it_quickapp from "./locales/it/quickapp.json";
import it_orders from "./locales/it/orders.json";
import it_bookings from "./locales/it/bookings.json";
import it_products from "./locales/it/products.json";
import it_beverages from "./locales/it/beverages.json";
import it_wine from "./locales/it/wine.json";
import it_category from "./locales/it/category.json";
import it_account from "./locales/it/account.json";
import it_auth from "./locales/it/auth.json";
import it_users from "./locales/it/users.json";
import en_common from "./locales/en/common.json";
import en_nav from "./locales/en/nav.json";
import en_dashboard from "./locales/en/dashboard.json";
import en_tables from "./locales/en/tables.json";
import en_cards from "./locales/en/cards.json";
import en_producers from "./locales/en/producers.json";
import en_quickapp from "./locales/en/quickapp.json";
import en_orders from "./locales/en/orders.json";
import en_bookings from "./locales/en/bookings.json";
import en_products from "./locales/en/products.json";
import en_beverages from "./locales/en/beverages.json";
import en_wine from "./locales/en/wine.json";
import en_category from "./locales/en/category.json";
import en_account from "./locales/en/account.json";
import en_auth from "./locales/en/auth.json";
import en_users from "./locales/en/users.json";

const NAMESPACES = ["common", "nav", "dashboard", "tables", "cards", "producers", "quickapp", "orders", "bookings", "products", "beverages", "wine", "category", "account", "auth", "users"];

const it = { common: it_common, nav: it_nav, dashboard: it_dashboard, tables: it_tables, cards: it_cards, producers: it_producers, quickapp: it_quickapp, orders: it_orders, bookings: it_bookings, products: it_products, beverages: it_beverages, wine: it_wine, category: it_category, account: it_account, auth: it_auth, users: it_users };
const en = { common: en_common, nav: en_nav, dashboard: en_dashboard, tables: en_tables, cards: en_cards, producers: en_producers, quickapp: en_quickapp, orders: en_orders, bookings: en_bookings, products: en_products, beverages: en_beverages, wine: en_wine, category: en_category, account: en_account, auth: en_auth, users: en_users };

export const LANGUAGES = [["it", "Italiano"], ["en", "English"]];
const STORE = "lang";

const initial = () => {
  try {
    const saved = localStorage.getItem(STORE);
    if (saved === "it" || saved === "en") return saved;
  } catch (e) { /* senza storage si parte dall'italiano */ }
  return "it";
};

i18n.use(initReactI18next).init({
  resources: { it, en },
  lng: initial(),
  fallbackLng: "it",
  ns: NAMESPACES,
  defaultNS: "common",
  interpolation: { escapeValue: false },
  returnNull: false,
});

if (typeof document !== "undefined") document.documentElement.lang = i18n.language;

// Cambia lingua e la ricorda per la prossima volta.
export const setLanguage = (lng) => {
  i18n.changeLanguage(lng);
  try { localStorage.setItem(STORE, lng); } catch (e) { /* ignora */ }
  if (typeof document !== "undefined") document.documentElement.lang = lng;
};

export default i18n;
